// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://api.aiautobase.com";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFxeWJvZW54aGxrcnBiZXZhcXZyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1MTc0NTYsImV4cCI6MjA3MTA5MzQ1Nn0.z7l3FLPeYCS8pmFxEHqQ42J3WjitBDksIBZnzDa4rmQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});